// extracted by mini-css-extract-plugin
export var filterIncDec = "_fm-0";
export var leftBorder = "_fm-1";
export var rightBorder = "_fm-2";
export var stringInput = "_fm-3";